export const columns = [
    {
        Header: 'Invoice ID',
        accessor: 'id',
    },
    {
        Header: 'Employee',
        accessor: 'user_id'
    },
    {
        Header: 'Period',
        accessor: 'date_from',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        disableSortBy: true,
        disableGlobalFilter: true,
    },
];